import { render } from "./externalLmsRegistrations.vue?vue&type=template&id=522f3144"
import script from "./externalLmsRegistrations.vue?vue&type=script&setup=true&lang=js"
export * from "./externalLmsRegistrations.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./externalLmsRegistrations.vue?vue&type=style&index=0&id=522f3144&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./externalLmsRegistrations.vue?vue&type=style&index=0&id=522f3144&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("522f3144")
  })
}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/vueComponents/admin/externalLmsRegistrations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "522f3144"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('522f3144', __exports__)) {
    api.reload('522f3144', __exports__)
  }
  
  module.hot.accept("./externalLmsRegistrations.vue?vue&type=template&id=522f3144", () => {
    api.rerender('522f3144', render)
  })

}


export default __exports__